import script from "./IisLimit.vue?vue&type=script&setup=true&lang=js"
export * from "./IisLimit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__